import { NgModule } from '@angular/core';
import { BaseStorefrontModule } from '@spartacus/storefront';
import { ActiveCartService, MultiCartService, SelectiveCartService } from '@spartacus/cart/base/core';
import { SpartacusFeaturesModule } from './spartacus-features.module';
import { SpartacusConfigurationModule } from './spartacus-configuration.module';

@NgModule({
  imports: [BaseStorefrontModule, SpartacusFeaturesModule, SpartacusConfigurationModule],
  exports: [BaseStorefrontModule],
  providers: [MultiCartService, ActiveCartService, SelectiveCartService],
})
export class SpartacusModule {}
